<template>
  <div class="bg">
    <div class="list-wrapper">

      <div class="title"></div>
      <div class="list" ref="list">
        <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="disable"
            infinite-scroll-distance="30">
          <li v-for="student in students" :key="student.id" v-tap="{methods:goToStudentInfo,student:student}">
            <span class="name">{{student.name}}</span>
            <span style="flex: 1"></span>
            <span class="class">{{student.gradeName}}</span>
            <i class="arrow"></i>
          </li>
        </ul>
      <div class="centerDiv"><span v-text="stateText"></span></div>
      </div>
      <div class="btn-wrapper">
        <v-go-back-btn></v-go-back-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import WorkerFilter from '../components/WorkerFilter.vue';
  import VGoBackBtn from '../components/VGoBackBtn.vue';
  import Teacher from '../api/teacher';
  import { mapGetters } from 'vuex';
  import { Toast, Indicator } from 'mint-ui';
  export default{
    name: '',
    created() {
      window.addEventListener('online', this.handleNetworkChange);
      window.addEventListener('offline', this.handleNetworkChange);
      this.getAllStudentsByGrade();
      let _that = this;
      this.$nextTick(function () {
        _that.$refs.list.onscroll = function () {
          _that.scrollTop = this.scrollTop;
        };
      });
    },
    destroyed() {
      window.removeEventListener('online', this.handleNetworkChange);
      window.removeEventListener('offline', this.handleNetworkChange);
    },
    activated() {
      this.$refs.list.scrollTop = this.scrollTop;
    },
    data() {
      return {
        isOnline: navigator.onLine,  // 初始时判断是否有网络
        students: [],
        page: 1,
        totalPage: 0,
        disable: false,
        scrollTop: 0,
        loadingState: 1 // 1-正常隐藏状态 2-加载状态 3-到底状态 4-nothing状态 5-网络情况差
      };
    },
    methods: {
      getAllStudentsByGrade() {
        this.disable = true;
        Indicator.open({text: '获取中...', spinnerType: 'fading-circle'});
        Teacher.getStudents(this.school.id, this.grade.id, this.page).then(response => {
          if (response.code==0) {
            if (response.data.pageNum === 1) {
              this.students = response.data.list;
            } else {
              this.students = this.students.concat(response.data.list);
            }
            this.page = response.data.pageNum;//当前页
            this.totalPage = response.data.pages; //一页显示总条数
            this.disable = this.page >= this.totalPage;//总页数
            if (this.disable) {
              if (this.students.length === 0) {
                this.setLoadingState(4);
              } else {
                this.setLoadingState(3);
              }
            } else {
              // 还有下一页正常隐藏
              this.setLoadingState(1);
            }
          } else {
            this.setLoadingState(4);
          }
          Indicator.close();
          this.disable = this.page === this.totalPage;
        }).catch(e => {
          this.setLoadingState(4);
          Indicator.close();
          this.disable = false;
        });
      },
      loadMore() {
        if(this.loadingState!=4&&this.loadingState!=5){
          this.page++;
          this.getAllStudentsByGrade();
        }
      },
      goToStudentInfo({student}) {
        this.$router.push({
          path: '/student-profile',
          query: {
            // school_id: student.school_id,
            // grade_id: student.grade_id,
            headId: student.id
          }
        });
      },
      setLoadingState(state) {
        this.loadingState = state;
      },
      handleNetworkChange() {
        this.isOnline = navigator.onLine;  // 更新网络状态
        if (!this.isOnline) {
          // 处理没有网络的情况
          this.setLoadingState(5);
        } else {
          // 处理有网络的情况
          // 例如：重新启用网络请求
          this.getAllStudentsByGrade();
        }
      }
    },
    components: {
      VGoBackBtn,
      WorkerFilter,
      Toast,
      Indicator
    },
    computed: {
      ...mapGetters({
        school: 'school',
        grade: 'grade'
      }),
      stateText() {
        let text = '';
        switch (this.loadingState) {
          case 1:
            text = '';
            break;
          case 2:
            text = '加载中...';
            break;
          case 3:
            text = '到底了...';
            break;
          case 4:
            text = '暂无记录';
            break;
          case 5:
            text = '请检查您的网络';
            break;
        }
        return text;
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base';

  .bg {
    @include bg-img('../assets/img/common/Bg');
    width: 100%;
    .list-wrapper {
      position: absolute;
      left: px2rem(40);
      width: px2rem(670);
      height: px2rem(1090);
      top: px2rem(122);
      @include bg-img('../assets/img/teacher/student_list_bg');
      .title {
        position: absolute;
        width: px2rem(431);
        left: px2rem(112);
        top: px2rem(-50);
        height: px2rem(111);
        @include bg-img('../assets/img/teacher/huamingce');
      }

      .list {
        width: px2rem(515);
        height: px2rem(806);
        position: absolute;
        left: px2rem(70);
        top: px2rem(96);
        overflow-y: auto;
        overflow-x: hidden;
        .centerDiv{
          margin-top:px2rem(60);
          font-size: px2rem(30);
          width:100%;
          height: 100%;
          text-align: center;
        }
        ul li {
          display: flex;
          flex-direction: row;
          color: #636363;
          font-size: px2rem(28);
          height: px2rem(60);
          line-height: px2rem(60);
          border-bottom: 1px solid #7e581f;
          .name {
            max-width: 30%;
            overflow: hidden;
          }
          .class {
            margin-right: px2rem(15);
            overflow: hidden;
          }
          .arrow {
            display: inline-block;
            width: px2rem(32);
            height: px2rem(32);
            margin-top: px2rem(12);
            background: url('../assets/img/common/right.png') no-repeat 0 0;
            background-size: 100% 100%;
          }
        }
      }

      .btn-wrapper {
        position: absolute;
        bottom: px2rem(70);
        left: px2rem(-30);
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// StudentList.vue?fe96a5e4